import { useState } from 'react';
import { X, Sparkles } from 'lucide-react';
import { useSettings } from '@/store/selectors';

const STORAGE_KEY = 'amg:firstRunNudgeDismissed';

/**
 * One-time first-run nudge pointing new pharmacists at "Load Demo" to lower the
 * activation barrier (critique: first run is a dense wall of fields behind the
 * disclaimer modal). Dismissal is remembered in localStorage; only surfaces when
 * the Load Demo button is itself visible.
 */
export function FirstRunNudge(): JSX.Element | null {
  const settings = useSettings();
  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (dismissed || !settings.showLoadDemo) return null;

  const dismiss = (): void => {
    setDismissed(true);
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore (private mode / disabled storage)
    }
  };

  return (
    <div className="first-run-nudge" role="note" data-testid="first-run-nudge">
      <Sparkles size={16} strokeWidth={2} aria-hidden="true" />
      <span className="first-run-nudge-text">
        <strong>New here?</strong> Use <strong>Load Demo</strong> (top right) to walk
        through a worked patient example.
      </span>
      <button
        type="button"
        className="first-run-nudge-dismiss"
        onClick={dismiss}
        aria-label="Dismiss getting started tip"
        data-testid="dismiss-first-run-nudge"
      >
        <X size={14} strokeWidth={2} />
      </button>
    </div>
  );
}
